var _excluded = ["steps", "onChange"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import StepButton from '@mui/material/StepButton';
import Step from '@mui/material/Step';
import MuiStepper from '@mui/material/Stepper';
import StepLabel from '@mui/material/StepLabel';
import useMediaQuery from '@mui/material/useMediaQuery';
import StepIcon from './StepIcon';
import Heading from './Heading';
import { StyledContainer } from './Stepper.styled';
function Stepper(_ref) {
  var steps = _ref.steps,
    onChange = _ref.onChange,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('sm');
  });
  var _React$useState = React.useState(0),
    activeStep = _React$useState[0],
    setActiveStep = _React$useState[1];
  var handleStep = function handleStep(step) {
    return function () {
      setActiveStep(step);
      onChange(step);
    };
  };
  return /*#__PURE__*/React.createElement(StyledContainer, {
    isMobile: isMobile
  }, isMobile && /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    align: "center",
    gutterBottom: false
  }, steps[activeStep].label), /*#__PURE__*/React.createElement(MuiStepper, _extends({
    alternativeLabel: true,
    activeStep: activeStep
  }, rest, {
    style: {
      padding: isMobile ? '18px 0' : '5px 0px 24px 0px'
    }
  }), steps.map(function (_ref2, index) {
    var label = _ref2.label,
      error = _ref2.error,
      completed = _ref2.completed,
      disabled = _ref2.disabled;
    return /*#__PURE__*/React.createElement(Step, {
      key: label,
      completed: completed,
      disabled: !!disabled
    }, /*#__PURE__*/React.createElement(StepButton, {
      onClick: handleStep(index)
    }, /*#__PURE__*/React.createElement(StepLabel, {
      error: error,
      StepIconComponent: StepIcon
    }, !isMobile && label)));
  })));
}
Stepper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Array of step labels
   */
  steps: PropTypes.arrayOf(PropTypes.shape({
    optional: PropTypes.bool,
    label: PropTypes.string,
    error: PropTypes.bool,
    completed: PropTypes.bool,
    disabled: PropTypes.bool
  })).isRequired,
  /**
   * Function to trigger action when activeStep changes...
   */
  onChange: PropTypes.func
} : {};
Stepper.defaultProps = {
  onChange: function onChange() {
    return null;
  }
};
export default Stepper;